import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';

@Component({})
export default class OCContentBox extends Mixins(BASEComponentVue) {
}
